import {Link, useSearchParams, useLocation} from 'react-router-dom'
import {NavigationTabsProps} from '../NavigationTypes'
import {KTSVG} from '../../../_metronic/helpers'
import {isEmpty} from '../../../utils/common'

export const NavigationTabs = ({
  id = 'navigation-tabs',
  navigations,
  className,
  disableSearchParams,
  baseUrl,
  paramKey,
  searchParams: defaultSearchParams,
  onChange,
}: NavigationTabsProps) => {
  const [searchParams] = useSearchParams()
  const location = useLocation()

  return (
    <ul
      id={`${id}-nav-tabs`}
      className={`nav nav-stretch nav-line-tabs nav-line-tabs-2x fs-5 fw-bold flex-nowrap mb-10 ${className}`}
    >
      {navigations.map((item) => {
        const componentSearchParams = !isEmpty(item?.searchParams)
          ? item?.searchParams
          : !isEmpty(defaultSearchParams)
          ? defaultSearchParams
          : null
        const to = disableSearchParams
          ? item.key === '/'
            ? baseUrl.replace(/\/$/, '')
            : `${baseUrl.replace(/\/$/, '')}/${item.key}`
          : !isEmpty(componentSearchParams)
          ? `${baseUrl}?${paramKey}=${item.key}&${Object.entries(componentSearchParams || {})
              .map(([key, value]) => `${key}=${value}`)
              .join('&')}`
          : `${baseUrl}?${paramKey}=${item.key}`

        const isActive = disableSearchParams
          ? location.pathname === to
          : searchParams.get(paramKey) === item.key

        return (
          <li
            className={`nav-item ${item.className || ''}`}
            key={item.key}
            onClick={() => onChange?.(item.key)}
          >
            <Link
              className={`nav-link text-active-primary cursor-pointer ${isActive ? 'active' : ''} ${
                item.disabled ? 'disabled' : ''
              } ${item.hide ? 'd-none' : ''}`}
              to={to}
              onClick={(e) => item.disabled && e.preventDefault()}
            >
              {item.icon && <KTSVG path={item.icon} className='me-2' />}
              {item.label}
            </Link>
          </li>
        )
      })}
    </ul>
  )
}
